export default __webpack_public_path__ + "static/thehub-sm@2x-33f765f73385a3959f665ad5c2500b5f.png";